import React from 'react';
import { message, Tabs, Icon } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import auth from '../../../common/utility/auth';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';
import dialog from '../../../common/utility/dialog';

import clienteService from "../../../service/administracion/clienteService";
import registroVentaSireService from '../../../service/ventas/registroVentaSireService';
import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import ResultListSire from './ResultListSire';
import ResultListSireAnexo5 from './ResultListSireAnexo5';

// import FormModal from './FormModal';
const { TabPane } = Tabs;

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSIRE: false,
            loadingTxt: false,
            loadingTicket: false,
            key: "2",
            series: [],
            clientes: [],
            filter: {
                loadingExcel: false,
                loadingPdf: false,
                loadingPdfRegistrado: false,
                loadingSIRE: false,
                periodoTributario: global.fetchCurrentAnioMesStr(),
                periodoAnterior: global.fetchCurrentAnioMesStr(),
                idCliente: 0,
                selectedItems: [],
                idAnexo: 2,
                idLibro: 1,
                idArchivo: 1,
                codTipoArchivo: 0,
                codLibro: '140000',
                perPage: 20,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            libros: [
                { id: 1, value: '140000', nombre: 'SIRE Registro de Ventas 140400' },
                // { id: 2, value: '080400', nombre: 'SIRE Registro de Compras 080400 - COMPARAR O REEMPLAZAR LA PROPUESTA' }
            ],
            tipoArchivo: [
                { id: 1, value: 0, nombre: 'TXT' },
                //{ id: 2, value: 1, nombre: 'EXCEL' },
                //{ id: 3, value: 2, nombre: 'CSV' }

            ],
            anexos: [
                { id: 1, value: 1, nombre: 'Anexo 2-Agregar CP Fisicos' },
                { id: 2, value: 2, nombre: 'Anexo 3-Comparar o Reemplazar' },
                { id: 3, value: 3, nombre: 'Anexo 4-Ajuste SIRE' },
                { id: 4, value: 4, nombre: 'Anexo 5-Ajuste PLE o Portal' },
                { id: 5, value: 5, nombre: 'Anexo 5-Ajuste PLE o Simplificado' },

            ],
        }
    }

    handleClearFilters = () => {
        var filter = {
            periodoTributario: global.fetchCurrentAnioMesStr(),
            periodoAnterior: global.fetchCurrentAnioMesStr(),
            idCliente: 0,
            selectedItems: [],
            idAnexo: 2,
            idLibro: 1,
            idArchivo: 1,
            codTipoArchivo: 0,
            codLibro: '140000',
            perPage: 20,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        if (property == 'idLibro') {
            var tipoLibro = this.state.libros.filter(e => e.id == value);
            filter.codLibro = tipoLibro.length > '140000' ? tipoLibro[0].value : 0;
        }
        if (property == 'idArchivo') {
            var tipoArchivo = this.state.tipoArchivo.filter(e => e.id == value);
            filter.codTipoArchivo = tipoArchivo.length > 0 ? tipoArchivo[0].value : 0;
        }

        if (property == 'idAnexo' && (value == 4 || value == 5)) {
            filter.idCliente = 0;
            filter.selectedItems = [];
        }

        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await registroVentaSireService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined) {
                var nombreArchivo = await this.GenerateNameSIRE(response.data);
                global.dowloadFile(response.data, nombreArchivo.replace(".txt", ".xlsx"));

            }
        });
    };

    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await registroVentaSireService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined) {
                var nombreArchivo = await this.GenerateNameSIRE(response.data);
                global.dowloadFile(response.data, nombreArchivo.replace(".txt", ".pdf"));
            }

        });
    };


    handleExportSIRE = async () => {

        this.setState({ loadingSIRE: true, filter: { ...this.state.filter } });
        var response = undefined;

        if (this.state.filter.idAnexo == 4 || this.state.filter == 5) {
            response = await registroVentaSireService.sireAnexo5(this.state.filter);

        } else {
            response = await registroVentaSireService.sire(this.state.filter);
        }

        this.setState({ loadingSIRE: false });

        var nombreArchivo = await this.GenerateNameSIRE(response.data);

        if (response.data !== undefined)
            global.dowloadFile(response.data, nombreArchivo);
    };

    GenerateNameSIRE = async (data) => {

        var fechaInicio = this.state.filter.periodoTributario;
        var valuesFechaInicio = fechaInicio.split('-');
        var anio = valuesFechaInicio[0];
        var mes = valuesFechaInicio[1];
        var ruc = auth.user().ruc;
        var identificadorLibro = "140400";
        var nombreArchivo = '';
        var codigoAgregar = "CPF";

        var codigoOportunidad = "";
        var indicadorOperaciones = "1";
        var indicadorContenido = "0";
        var indicadorMoneda = "1";
        var indicadorLibro = "2";
        var correlativoAjuste = "01";

        if (data.size > 0) {
            indicadorContenido = "1";
        }
        if (this.state.filter.idAnexo == 1) {  //anexo 2
            nombreArchivo = ruc + "-" + codigoAgregar + "-" + anio + mes + "-" + "01" + ".txt";

            return nombreArchivo;
        }
        if (this.state.filter.idAnexo == 2) {  //anexo 3
            codigoOportunidad = "02";//RVIE cuando reemplaza la propuesta
            nombreArchivo = "LE" + ruc + anio + mes + "00" + identificadorLibro + codigoOportunidad + indicadorOperaciones + indicadorContenido + indicadorMoneda + indicadorLibro + ".txt";
            return nombreArchivo;
        }
        if (this.state.filter.idAnexo == 3) { //anexo 4 
            codigoOportunidad = "03";//RVIE cuando se realiza ajustes posteriores
            nombreArchivo = "LE" + ruc + anio + mes + "00" + identificadorLibro +
                codigoOportunidad + indicadorOperaciones + indicadorContenido + indicadorMoneda + indicadorLibro + correlativoAjuste + ".txt";
            return nombreArchivo;
        }

        if (this.state.filter.idAnexo == 4) { //anexo 5 
            codigoOportunidad = "04";//Reporte de Ajustes Posteriores de Periodos Anteriores al Nuevo Sistema de Registros-Formato General
            nombreArchivo = "LE" + ruc + anio + mes + "00" + identificadorLibro +
                codigoOportunidad + indicadorOperaciones + indicadorContenido + indicadorMoneda + indicadorLibro + correlativoAjuste + ".txt";
            return nombreArchivo;
        }

        if (this.state.filter.idAnexo == 5) { //anexo 5 
            codigoOportunidad = "05";//Reporte de Ajustes Posteriores de Periodos Anteriores al Nuevo Sistema de Registros-Formato Simplificado
            nombreArchivo = "LE" + ruc + anio + mes + "00" + identificadorLibro +
                codigoOportunidad + indicadorOperaciones + indicadorContenido + indicadorMoneda + indicadorLibro + correlativoAjuste + ".txt";
            return nombreArchivo;
        }
    };

    handleConsultaSire = async () => {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var fechaHoy = yyyy + '-' + mm;

        if (this.state.filter.periodoTributario == fechaHoy) {
            dialog.error('Solo se permite periodos anteriores al mes actual  ');
            return false;
        }
        if (this.state.key == "1") {
            this._initPagination(this.state.filter, registroVentaSireService.paginacion);

            setTimeout(async () => {
                if (this.state.pagination.data.length == 0) {
                    var response = await registroVentaSireService.consulta_sire(this.state.filter);
                    if (response.status === 200) {
                        message.success('Proceso realizado.');
                        this._handlePagination(this.state.filter);
                        return;
                    }
                    if (response.status === 400) {
                        dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                        return;
                    }

                    dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
                }
            }, 4000)
        } else {

            if (this.state.filter.idAnexo == 4 || this.state.filter.idAnexo == 5) {

                this._initPagination(this.state.filter, registroVentaSireService.paginacionSireAnexo5);
            } else {

                this._initPagination(this.state.filter, registroVentaSireService.paginacionSire);
            }
        }

    };

    handleConsultaTicekt = async (item) => {
        this.setState({ loadingTicket: true });
        var filter = this.state.filter;
        filter.numeroTicket = item.numeroTicket;
        filter.periodoTributario = item.periodoTributario;
        var response = await registroVentaSireService.consulta_sire(this.state.filter);

        if (response != undefined) {
            this._initPagination(this.state.filter, registroVentaSireService.paginacion);
        }
        this.setState({ loadingTicket: false });
    };

    handleDownloadSire = async (item) => {
        this.setState({ loadingTxt: true });
        var response = await registroVentaSireService.sireSunat(item);
        if (response !== undefined) {
            global.dowloadFile(response.data, item.nombreArchivoReporte);
        }
        this.setState({ loadingTxt: false });
    };

    handlePagination = (e) => {

        if (e == "1") {
            this._initPagination(this.state.filter, registroVentaSireService.paginacion);

        } else {
            this._initPagination(this.state.filter, registroVentaSireService.paginacionSire);

        }
        this.setState({ key: e })
    }


    async componentDidMount() {
        this._isMounted = true;
        this._initPagination(this.state.filter, registroVentaSireService.paginacionSire);

        const series = await registroVentaSireService.listarSeries();
        const clientes = await clienteService.listar();

        if (this._isMounted) {
            this.setState({
                loadingEdit: false,
                loadingSource: false,
                series: series ? series : [],
                clientes: clientes ? clientes : []
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    };


    render() {
        return (
            <div>
                <Header
                    title="Registro de Ventas SIRE"
                    onSearch={this.handleConsultaSire}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onChange={this.handleChange}
                    libros={this.state.libros}
                    tipoArchivo={this.state.tipoArchivo}
                    anexos={this.state.anexos}
                    series={this.state.series}
                    clientes={this.state.clientes}
                />

                <Tabs defaultActiveKey={this.state.key}
                    onChange={this.handlePagination}
                >
                    <TabPane
                        tab={
                            <span>
                                <Icon type="unordered-list" />
                                Registro de venta SIRE SUNAT
                            </span>
                        }
                        key="1"
                    >
                        <ResultList
                            pagination={this.state.pagination}
                            loadingTxt={this.state.loadingTxt}
                            loadingTicket={this.state.loadingTicket}
                            loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                            loadingSIRE={this.state.loadingSIRE}
                            onChange={this._handleChangePagination}
                            onDownloadSire={this.handleDownloadSire}
                            handleConsultaTicekt={this.handleConsultaTicekt}

                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span>
                                <Icon type="unordered-list" />
                                Registro de venta SIRE ACSOFT ERP
                            </span>
                        }
                        key="2"
                    >

                        {[4, 5].includes(this.state.filter.idAnexo) ?
                            <ResultListSireAnexo5
                                pagination={this.state.pagination}
                                loadingTxt={this.state.loadingTxt}
                                loadingExcel={this.state.loadingExcel}
                                loadingPdf={this.state.loadingPdf}
                                loadingTicket={this.state.loadingTicket}
                                loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                                loadingSIRE={this.state.loadingSIRE}
                                onExportExcel={this.handleExportExcel}
                                onExportPdf={this.handleExportPdf}
                                onExportSIRE={this.handleExportSIRE}
                                onChange={this._handleChangePagination}
                                onDownloadSire={this.handleDownloadSire}
                                handleConsultaTicekt={this.handleConsultaTicekt}
                            /> :
                            <ResultListSire
                                pagination={this.state.pagination}
                                loadingTxt={this.state.loadingTxt}
                                loadingExcel={this.state.loadingExcel}
                                loadingPdf={this.state.loadingPdf}
                                loadingTicket={this.state.loadingTicket}
                                loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                                loadingSIRE={this.state.loadingSIRE}
                                onExportExcel={this.handleExportExcel}
                                onExportPdf={this.handleExportPdf}
                                onExportSIRE={this.handleExportSIRE}
                                onChange={this._handleChangePagination}
                                onDownloadSire={this.handleDownloadSire}
                                handleConsultaTicekt={this.handleConsultaTicekt}
                            />
                        }

                    </TabPane>
                </Tabs>

            </div>
        );
    }
}